<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  type: 'success' | 'error'
  title: string
  message: string
}>()

const isSuccess = computed(() => props.type === 'success')
</script>

<template>
  <div class="flex flex-col items-center justify-center text-center py-10 px-6 h-full min-h-[350px] animate-fadeIn">
    
    <div 
      class="flex h-16 w-16 items-center justify-center rounded-full mb-6 transition-colors duration-300"
      :class="isSuccess ? 'bg-green-100 text-green-600 dark:bg-green-900 dark:text-green-400' : 'bg-red-100 text-red-600 dark:bg-red-900 dark:text-red-400'"
    >
      <svg v-if="isSuccess" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>

    <h3 class="mb-3 text-xl font-bold text-black dark:text-white">
      {{ title }}
    </h3>

    <p class="text-base leading-relaxed text-slate-600 dark:text-gray-300 max-w-lg mx-auto">
      {{ message }}
    </p>

    <div class="mt-8 w-full flex justify-center gap-4">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.animate-fadeIn {
  animation: fadeIn 0.4s ease-out;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>